import IconGenerator from "@/components/shared/IconGenerator";
import { EventTypes } from "@/enums/RecapEnums";
import useResponsive from "@/hooks/useResponsive.hook";
import { RecapHeaderProps } from "@/interfaces/IRecap";
import { Flex, Select, Tag, Typography } from "antd";
import RecapPrint from "../print/RecapPrint";
import Participants from "./Participants";

const { Text } = Typography;

const Header = ({
  meetTitle,
  selectedSession,
  onSessionChange,
  placeholder,
  options,
  eventType,
  overview,
  participants,
  isLoadingParticipants,
  printData,
}: RecapHeaderProps) => {
  const isResponsive = useResponsive();

  const eventTypeOption = EventTypes().find((item) => item.value === eventType);

  return (
    <Flex
      vertical
      gap={20}
      className={
        isResponsive
          ? "recap-header-wrapper"
          : "recap-header-wrapper border px-5 py-4"
      }
    >
      <Flex
        gap={isResponsive ? 20 : 12}
        align={isResponsive ? "flex-start" : "center"}
        vertical={isResponsive}
      >
        {!isResponsive ? (
          <>
            {eventTypeOption?.label && (
              <Tag className="m-0 session-type">{eventTypeOption.label}</Tag>
            )}

            <Flex align="center" justify="space-between" flex={1}>
              <Select
                bordered={false}
                className="session-select"
                value={selectedSession}
                onChange={onSessionChange}
                placeholder={placeholder}
                options={options}
                optionLabelProp="selectedLabel"
              />

              <RecapPrint data={printData} />
            </Flex>
          </>
        ) : (
          <>
            <Select
              bordered={false}
              className="session-select"
              value={selectedSession}
              onChange={onSessionChange}
              placeholder={placeholder}
              options={options}
              optionLabelProp="selectedLabel"
            />

            <Flex justify="space-between" align="center" className="w-100">
              {eventTypeOption?.label && (
                <Tag className="session-type">{eventTypeOption.label}</Tag>
              )}

              <RecapPrint data={printData} />
            </Flex>
          </>
        )}
      </Flex>

      <Flex vertical gap={4}>
        <Text className="font-weight-500 h4">{meetTitle?.trim()}</Text>

        {overview ? (
          <Flex align="center" gap={8}>
            <IconGenerator name={"RosaLogo"} size={16} />
            <Text type="secondary"> {overview}</Text>
          </Flex>
        ) : null}
      </Flex>

      <Participants
        participants={participants}
        isLoading={isLoadingParticipants}
      />
    </Flex>
  );
};

export default Header;
